import React, { useState } from "react";
import { requestMagicLink } from "../api";

export default function Login() {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState("idle"); // idle | loading | sent | error
  const [errorMessage, setErrorMessage] = useState("");

  async function handleSubmit(e) {
    e.preventDefault();
    if (!email.trim()) return;
    setStatus("loading");
    setErrorMessage("");
    try {
      await requestMagicLink(email.trim());
      setStatus("sent");
    } catch (err) {
      setStatus("error");
      setErrorMessage(err.message || "Something went wrong. Please try again.");
    }
  }

  return (
    <div className="page">
      <div className="card">
        <h1>Client Dashboard</h1>
        <p className="muted">Sign in with the email you used at checkout — we'll send you a one-time link.</p>
        <form onSubmit={handleSubmit}>
          <label htmlFor="email">Email address</label>
          <input
            id="email"
            type="email"
            required
            placeholder="you@yourbusiness.com"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            disabled={status === "loading" || status === "sent"}
          />
          <button type="submit" className="btn-primary" disabled={status === "loading" || status === "sent"}>
            {status === "loading" ? "Sending…" : "Send sign-in link"}
          </button>
        </form>
        {status === "sent" && (
          <div className="alert alert-success">
            Check your inbox — the link expires in 15 minutes and works once.
          </div>
        )}
        {status === "error" && <div className="alert alert-error">{errorMessage}</div>}
      </div>
    </div>
  );
}
